import { FunctionComponent } from "react";
import { useOktaAuth } from '@okta/okta-react';
import { LoadingIndicator } from "src/components/LoadingIndicator";
import { Redirect } from "react-router-dom";


const Login: FunctionComponent = () => {

  const { authState, oktaAuth } = useOktaAuth();

  async function login() {

    await oktaAuth.signInWithRedirect({
      originalUri: '/home',
    });
  }

  authState?.isAuthenticated ? <Redirect to="/home" /> : login()

  return <LoadingIndicator busy={!authState?.isAuthenticated} />

}

export default Login;